"use strict";

var _interopRequireDefault = require("/opt/build/repo/node_modules/@babel/runtime/helpers/interopRequireDefault");

var _objectSpread2 = _interopRequireDefault(require("/opt/build/repo/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/opt/build/repo/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _router = _interopRequireDefault(require("./router"));

var _store = _interopRequireDefault(require("./store"));

var _elementUi = require("element-ui");

var _nprogress = _interopRequireDefault(require("nprogress"));

require("nprogress/nprogress.css");

var _auth = require("@/utils/auth");

// progress bar
// progress bar style
// get token from cookie
// import getPageTitle from '@/utils/get-page-title'
_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration


var whiteList = ['/login', '/register', '/reset-passwords', '/email-verification-check']; // no redirect whitelist

_router.default.beforeEach( /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken, hasRoles, _yield$store$dispatch, roles, accessRoutes;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // start progress bar
            _nprogress.default.start(); // set page title
            // document.title = getPageTitle(to.meta.title)


            document.title = to.meta.title || '加载中...'; // determine whether the user has logged in

            hasToken = (0, _auth.getToken)();

            if (!hasToken) {
              _context.next = 36;
              break;
            }

            if (!(to.path === '/login')) {
              _context.next = 9;
              break;
            }

            // if is logged in, redirect to the home page
            // next({ path: '/home' })
            next("/"); // next()

            _nprogress.default.done();

            _context.next = 34;
            break;

          case 9:
            // determine whether the user has obtained his permission roles through getInfo
            hasRoles = _store.default.getters.roles && _store.default.getters.roles.length > 0;

            if (!hasRoles) {
              _context.next = 14;
              break;
            }

            next();
            _context.next = 34;
            break;

          case 14:
            _context.prev = 14;
            _context.next = 17;
            return _store.default.dispatch('user/getInfo');

          case 17:
            _yield$store$dispatch = _context.sent;
            roles = _yield$store$dispatch.roles;
            _context.next = 21;
            return _store.default.dispatch('permission/generateRoutes', roles);

          case 21:
            accessRoutes = _context.sent;

            // dynamically add accessible routes
            _router.default.addRoutes(accessRoutes); // next('/home')
            // hack method to ensure that addRoutes is complete
            // set the replace: true, so the navigation will not leave a history record


            next((0, _objectSpread2.default)((0, _objectSpread2.default)({}, to), {}, {
              replace: true
            }));
            /*
            await store.dispatch('user/getInfo')
            next()
            */

            _context.next = 34;
            break;

          case 26:
            _context.prev = 26;
            _context.t0 = _context["catch"](14);
            console.log('错误'); // remove token and go to login page to re-login

            _context.next = 31;
            return _store.default.dispatch('user/resetToken');

          case 31:
            _elementUi.Message.error(_context.t0 || 'Has Error');

            next("/login?redirect=".concat(to.path)); // next(`/login`)

            _nprogress.default.done();

          case 34:
            _context.next = 37;
            break;

          case 36:
            /* has no token*/
            if (whiteList.indexOf(to.path) !== -1) {
              // in the free login whitelist, go directly
              next();
            } else {
              // other pages that do not have permission to access are redirected to the login page.
              // next(`/login?redirect=${to.path}`)
              // next()
              next("/login");

              _nprogress.default.done();
            }

          case 37:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[14, 26]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});